import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  RankingListRequest,
  RankingListResponse,
  RegionRankings,
} from './ranking-api.def.ts'
import { formatStarScore } from '@/utils/formatters.ts'

const interfaceName = 'ranking'

export const rankingApi = createApi({
  reducerPath: 'rankingApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['ranking'],
  endpoints: (build) => ({
    listRanking: build.query<RankingListResponse, RankingListRequest>({
      query: (params) => ({
        url: '/',
        method: 'GET',
        params: params,
      }),
      transformResponse: (
        response: RankingListResponse
      ): RankingListResponse => {
        const rankingsGroup: RegionRankings = {}
        for (const region in response.data.rankingsGroup) {
          rankingsGroup[region] = response.data.rankingsGroup[region].map(
            (rank) => ({ ...rank, score: formatStarScore(rank.score) })
          )
        }
        return { data: { rankingsGroup } }
      },
      providesTags: ['ranking'],
    }),
  }),
})

export const { useListRankingQuery } = rankingApi
